import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";
import {AlertComponent} from "../../../../../app/components/alert/AlertComponent";

export function HashMapInsertLevelFullCaption() {
    return (<FullCaptionComponent title="VALUE: level">
        <HashMapInsertLevel1/>
        <HashMapInsertLevel2/>
        <HashMapInsertLevel3/>
        <HashMapInsertLevel4/>
        <HashMapInsertLevel5/>
    </FullCaptionComponent>)
}

export function HashMapInsertLevel1() {
    return (<CaptionStepComponent
        title={<h6>1. Check if our <CodeComponent className="codeValue">VALUE</CodeComponent> is
            unique. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>HashMaps only contain unique <CodeComponent className="codeValue">VALUES</CodeComponent>. We should first
            call our <CodeComponent>contains</CodeComponent> function to make sure we don't already have "level" in our
            HashMap. In this case, we do not already have "level", so we are good to continue.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertLevel2() {
    return (<CaptionStepComponent title={<h6>2. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Let's assume that if we input our <CodeComponent className="codeKey">KEY</CodeComponent> of "eellv" into
            our <CodeComponent>generateHash</CodeComponent> function, it will output a <CodeComponent
                className="codeHash">HASH</CodeComponent> of 5.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertLevel3() {
    return (<CaptionStepComponent title={<h6>3. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 5, we now want to find the
            sub-collection at index 5 of our array. Again, we see there is no collision to worry about, as there are no
            items located at index 5 yet.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertLevel4() {
    return (<CaptionStepComponent
        title={<h6>4. Insert <CodeComponent className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object into the
            sub-collection. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Next, we insert our <CodeComponent className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object of <CodeComponent>eellv - level</CodeComponent> into the
            sub-collection we found at index 5.</p>
    </CaptionStepComponent>)
}

export function HashMapInsertLevel5() {
    return (<CaptionStepComponent title={<h6>5. If necessary, increase HashMap space to maintain an optimal
        balance. <CodeComponent>O(n)</CodeComponent></h6>}>
        <p>We now have filled 4 items in our HashMap, or 50% of our slots filled. To make sure we limit our chances of
            collisions, we want to increase the size of our HashMap by doubling the size of our Array. When we re-size
            our HashMap, we need to <CodeComponent className="codeHash">REHASH</CodeComponent> all of our <CodeComponent
                className="codeKey">KEYS</CodeComponent> to determine the new <CodeComponent
                className="codeHash">HASH</CodeComponent> indices for each <CodeComponent
                className="codeKey">KEY</CodeComponent> - <CodeComponent
                className="codeValue">VALUE</CodeComponent> object in our map. In order to <CodeComponent
                className="codeHash">REHASH</CodeComponent>, we must repeat steps 1-4 for each of our <CodeComponent
                className="codeKey">KEYS</CodeComponent> we've already added to our HashMap. Even though steps 1-4
            are <CodeComponent>O(1)</CodeComponent> time complexity on their own, we will repeat the steps for the
            amount of items we have in our HashMap. If we have <CodeComponent>n</CodeComponent> items in our HashMap at
            the time we <CodeComponent className="codeHash">REHASH</CodeComponent>, this would make our time
            complexity<CodeComponent>O(n * 1)</CodeComponent> or, simplified, <CodeComponent>O(n)</CodeComponent>. Our
            hash function would remain the same, so let's quickly run through what our new <CodeComponent
                className="codeHash">HASHES</CodeComponent> will be for each of our <CodeComponent
                className="codeKey">KEYS</CodeComponent>.</p>
        <ul>
            <li><CodeComponent className="codeKey">act</CodeComponent> - <CodeComponent
                className="codeValue">cat</CodeComponent> = <CodeComponent className="codeHash">11</CodeComponent></li>
            <li><CodeComponent className="codeKey">abc</CodeComponent> - <CodeComponent
                className="codeValue">cab</CodeComponent> = <CodeComponent className="codeHash">1</CodeComponent></li>
            <li><CodeComponent className="codeKey">actt</CodeComponent> - <CodeComponent
                className="codeValue">tact</CodeComponent> = <CodeComponent className="codeHash">13</CodeComponent></li>
            <li><CodeComponent className="codeKey">eellv</CodeComponent> - <CodeComponent
                className="codeValue">level</CodeComponent> = <CodeComponent className="codeHash">3</CodeComponent></li>
        </ul>
        <AlertComponent color="light"><strong>NOTE:</strong> Remember, <CodeComponent
            className="codeHash">HASHES</CodeComponent> are derived from the <CodeComponent
            className="codeKey">KEYS</CodeComponent> only. In this case, we technically would only need to repeat steps
            1-4 for the unique <CodeComponent className="codeKey">KEYS</CodeComponent> in our HashMap. Then, moving the
            HEAD node from our LinkedList sub-collections, the remaining <CodeComponent
                className="codeKey">KEY</CodeComponent> - <CodeComponent
                className="codeValue">VALUE</CodeComponent> objects would automatically be reshuffled. Worst case time
            complexity will still hold steady at <CodeComponent>O(n)</CodeComponent> though, as in the worst case, no
            two (2) values share the same <CodeComponent className="codeKey">KEY</CodeComponent>. Which, is exactly what
            we have in our example here.</AlertComponent>
        <p>At this point, you just find the sub-collection at each of those <CodeComponent
            className="codeHash">HASH</CodeComponent> indexes, and insert the associated <CodeComponent
            className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object(s) into the sub-collections found there.</p>
    </CaptionStepComponent>)
}